import './global.css';
import App from './components/App.svelte';


console.log('main.js: Starting app initialization');
console.log('main.js: Target element:', document.getElementById('app'));

const app = new App({
  target: document.getElementById('app'),
  props: {}
});

console.log('main.js: App created successfully - single server mode');



export default app;